import * as Highcharts from "highcharts";
import * as Highstock from "highcharts/highstock";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";

export class GraphHelper {
    static InvestmentsGraph(chartId: string, chartType: string, chartDataSeries: any): void {
        Highstock.chart(chartId, {
            lang: {
                noData:
                    '<div className="table-skeleton full-width is-animated"><span className="sr-only">Loading data</span></div>',
            },
            title: { text: "" },
            colors: ["#147cb3", "#6e3694", "#4fbba3", "#a20067", "#830051", "#999999"],
            chart: {
                // height: 380,
                type: "line",
                style: {
                    fontFamily: "inherit",
                },
                backgroundColor: "transparent",
                zoomType: "xy",
                //margin: [3, 10, 40, 100],//top, right, bottom, left
                resetZoomButton: {
                    theme: {
                        fill: "white",
                        stroke: "#6eab24",
                        r: 3,
                        zIndex: 1,
                        states: {
                            hover: {
                                fill: "#c5daa7",
                                style: {
                                    color: "#000000",
                                },
                            },
                        },
                    },
                },
            },
            credits: {
                enabled: false,
            },
            rangeSelector: {
                enabled: false,
            },
            navigation: {
                buttonOptions: {
                    enabled: false,
                },
            },
            legend: {
                enabled: false,
            },
            xAxis: {
                crosshair: true,
                lineColor: "transparent",
                tickWidth: 0,
                tickLength: 0,
                tickColor: "#979797",
                type: "datetime",
                showFirstLabel: true,
                showLastLabel: true,
                gridLineWidth: 0,
                labels: {
                    align: "right",
                    enabled: true,
                    step: 1,
                    formatter: function () {
                        const date = new Date(this.value);
                        const month = JsonDateParser.getMonthNameMapping((date.getMonth() + 1).toString(), true);
                        const year = JsonDateParser.getFormatDate(JsonDateParser.toJsonDateNoOffset(date), "yy");

                        const formatDate = month + " " + year;
                        return formatDate;
                    },
                },
                title: {
                    text: "",
                },
                minRange: 24 * 3600 * 1000, // one day
            },
            yAxis: {
                gridLineColor: "#979797",
                lineColor: "#979797",
                lineWidth: 0,
                tickWidth: 0,
                tickLength: 0,
                tickColor: "#979797",
                opposite: false,
                labels: {
                    //align: "right",
                    ///x: -5,
                    //y: -4,
                    formatter: function () {
                        return MoneyDisplayHelper.FromatMoneyDisplay(this.value, CurrencyCode.GBP, true, 4);
                    },
                },
                min: 0,
                title: {
                    text: "",
                },
            },
            tooltip: {
                shared: false,
                shadow: false,
                backgroundColor: "#ffffff",
                headerFormat: "",
                formatter: function () {
                    return (
                        "Price value: <br/>£" +
                        Highcharts.numberFormat(this.y, 4, ".", ",") +
                        "<br/>as at " +
                        Highcharts.dateFormat("%d %b %Y", this.x)
                    );
                },
            },
            exporting: {
                enabled: false,
            },
            plotOptions: {
                line: {
                    lineWidth: 1,
                    states: {
                        hover: {
                            lineWidth: 2,
                        },
                    },
                },
                series: {
                    marker: { enabled: false },
                },
                spline: {
                    marker: {
                        radius: 4,
                        lineColor: "#666666",
                        lineWidth: 1,
                    },
                },
            },
            navigator: {
                enabled: true,
                maskFill: "rgba(255,255,255,0.75)",
                maskInside: false,
                outlineColor: "#BFBFBF",
                xAxis: {
                    labels: {
                        enabled: true,
                    },
                },
                handles: {
                    symbols: ["doublearrow", "doublearrow"],
                    backgroundColor: "#979797",
                    borderColor: "#4B4B4B",
                    enabled: true,
                    lineWidth: 1,
                    width: 26,
                    height: 26,
                },
                adaptToUpdatedData: false,
                series: {
                    lineColor: "#BFBFBF",
                    fillOpacity: 0,
                    type: "areaspline",
                    color: "#acbcc5",
                },
            },
            scrollbar: {
                enabled: true,
                barBackgroundColor: "#d8d8d8",
                barBorderRadius: 0,
                barBorderWidth: 0,
                barBorderColor: "#979797",
                buttonBackgroundColor: "#d8d8d8",
                buttonBorderColor: "#a1a7ac",
                buttonBorderWidth: 1,
                buttonArrowColor: "#666666",
                buttonBorderRadius: 0,
                rifleColor: "#666666",
                trackBackgroundColor: "#ffffff",
                trackBorderWidth: 1,
                trackBorderColor: "#a1a7ac",
                trackBorderRadius: 0,
                height: 20,
            },
            series: chartDataSeries,
        });
    }
}
